import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

interface ContactInfo {
  phone: string;
  email: string;
  wechat: string;
  whatsapp: string;
  address: string;
}

interface SiteSettings {
  logo_url: string;
  wechat_qr_url: string;
  whatsapp_qr_url: string;
  contact: ContactInfo;
}

const FALLBACK: SiteSettings = {
  logo_url: '/images/common/7a92bdcb-291f-426f-af8f-f2d2830f7154_RTB-LOGO.jpg',
  wechat_qr_url: '/images/common/e9b559dc-04a8-41c8-932e-07a7a1148d2f_unnamed.jpg',
  whatsapp_qr_url: '/images/common/5781bcaf-519e-44fe-ad77-a2de0a044dc7_whatsapp.jpg',
  contact: {
    phone: '+86 16600032397',
    email: 'ivfjason@gmail.com',
    wechat: '16600032397',
    whatsapp: '+86 18513885468',
    address: '吉尔吉斯斯坦·比什凯克',
  },
};

const CONTACT_KEYS = ['contact_phone', 'contact_email', 'contact_wechat', 'contact_whatsapp', 'contact_address'];

const ALL_KEYS = ['logo_url', 'wechat_qr_url', 'whatsapp_qr_url', ...CONTACT_KEYS];

export function useSiteSettings() {
  const [settings, setSettings] = useState<SiteSettings>(FALLBACK);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fetchSettings = async () => {
      const { data } = await supabase.from('site_settings').select('key, value').in('key', ALL_KEYS);
      if (cancelled) return;
      const map: Record<string, string> = {};
      (data ?? []).forEach((row) => { map[row.key] = row.value; });
      setSettings({
        logo_url: map.logo_url || FALLBACK.logo_url,
        wechat_qr_url: map.wechat_qr_url || FALLBACK.wechat_qr_url,
        whatsapp_qr_url: map.whatsapp_qr_url || FALLBACK.whatsapp_qr_url,
        contact: {
          phone: map.contact_phone || FALLBACK.contact.phone,
          email: map.contact_email || FALLBACK.contact.email,
          wechat: map.contact_wechat || FALLBACK.contact.wechat,
          whatsapp: map.contact_whatsapp || FALLBACK.contact.whatsapp,
          address: map.contact_address || FALLBACK.contact.address,
        },
      });
      setLoading(false);
    };
    fetchSettings();
    return () => { cancelled = true; };
  }, []);

  return { ...settings, loading };
}